import { Action, createReducer, on } from '@ngrx/store';
import { PaymentState } from '../model';
import { paymentStateActions } from './payment.actions';
import { paymentAdapter } from './payment.adapter';

export const initialPaymentState: PaymentState = paymentAdapter.getInitialState({
  entities: {},
  flightOffer: {} as any,
  flightOrder: {} as any,
  ids: [],
  loading: false,
  loaded: false,
  error: null,
  active: [],
});

export const PaymentStateFeatureKey = 'PaymentStateFeatureKey';

export const paymentReducer = createReducer(
  initialPaymentState,
  on(paymentStateActions.loadFlightOfferData,
    (state, action) => {
      
      return {
        ...state,
        loading: true,
        loaded: false,
      }
    }
  ),

  on(paymentStateActions.loadFlightOfferDataSuccess,
    (state, action) => {
      const { flightOffer } = action.data;
      
      return {
        ...state,
        flightOffer,
        loading: false,
        loaded: true,
      }
    }
  ),

  on(paymentStateActions.loadFlightOfferDataFailure,
    (state, action) => { //TODO: add errors
      
      return {
        ...state,
        loading: false,
        loaded: true,
      }
    }
  ),

  on(paymentStateActions.orderFlight,
    (state, action) => {
      
      return {
        ...state,
        loading: true,
        loaded: false,
      }
    }
  ),

  on(paymentStateActions.orderFlightSuccess,
    (state, action) => {
      const { flightOrder } = action.data;
      return {
        ...state,
        flightOrder,
        loading: false,
        loaded: true,
      }
    }
  ),

  on(paymentStateActions.orderFlightFailure,
    (state, action) => { //TODO: add errors
      
      return {
        ...state,
        loading: false,
        loaded: true,
      }
    }
  ),
);

export function PaymentReducer(state: PaymentState | undefined, action: Action) {
  return paymentReducer(state, action);
}
